import { render, staticRenderFns } from "./Second_setup.vue?vue&type=template&id=76a0e148&"
import script from "./Second_setup.vue?vue&type=script&lang=js&"
export * from "./Second_setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports